import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactService } from 'src/app/services/contact.service';
import { DxButtonModule, DxDataGridModule, DxTagBoxModule, DxTextBoxModule } from 'devextreme-angular';
import dxButton from 'devextreme/ui/button';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';
import { AppGlobals } from 'src/app/app.globals';
import { environment } from 'src/environments/environment';
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
import { GpdPillComponent } from "src/app/components/gpd-pill/gpd-pill.component";

import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';
@Component({
    selector: 'app-contacts-companies.page',
    imports: [CommonModule, DxDataGridModule, DxButtonModule, DxTagBoxModule, DxTextBoxModule, GpdButtonComponent, GpdPillComponent],
    templateUrl: './contacts-companies.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./contacts-companies.page.css']
})
export class ContactsCompaniesPageComponent {

  @ViewChild('companyGrid') companyGrid

  companies: any;
  contactTags: any;
  tagFilterDataSource: any[] = [];

  searchValue: any;
  searchFilter: any;
  searchTerm: string = '';

  dataGridHeight: any = '60vh'
  pageBreadCrumb: any = { text: $localize`Contacts/`, href: window.location.href, layer: 0 }
  
  constructor(private contactService: ContactService, private router: Router, private configService: ConfigService, private appGlobals: AppGlobals, private activityLog: ActivityLogService) { }

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONTACTS_COMPANY });
    this.appGlobals.SetGlobalMenuIndex(6);
    AppGlobals.clearBreadCrumbInLocalStorage();
    
    this.configService.getContactTags({}).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.contactTags = result.contactTags;
        // Create filter datasource immediately after tags are loaded
        this.createTagFilterDataSource();
        // Load companies after tags are loaded
        this.loadCompanies();
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }

  loadCompanies() {
    this.contactService.getCompanies({}).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.companies = result.companyItems;

        for (let i = 0; i < this.companies.length; i++) {
          this.companies[i].fullAddress = this.companies[i].address + ', ' + this.companies[i].zipcode + ' ' + this.companies[i].city;
          // Add tag names for easier filtering
          this.companies[i].tagNames = this.getTagNames(this.companies[i].tags);
        }
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }

  createTagFilterDataSource() {
    // Create datasource with text and value for ALL tags, not just used ones
    this.tagFilterDataSource = this.contactTags.map(tag => ({
      text: tag.title,
      value: tag.id
    }));
  }

  showDetails(e) {
    this.router.navigate(["./contacts/company/" + e.data.id]);
    AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
  }

  goToAddCompany() {
    this.router.navigate(["./contacts/addCompany"]);
    AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
  }

  getTag(item) {
    let tag = this.contactTags.find(tag => tag.id == item);
    if (tag != null) {
      return tag.title
    }
  }

  getTagNames(tagIds: any[]): string {
    if (!tagIds || !this.contactTags || tagIds.length === 0) return '';
    return tagIds.map(tagId => {
      let tag = this.contactTags.find(t => t.id == tagId);
      return tag ? tag.title : '';
    }).filter(name => name).join(', ');
  }

  // Custom filter function for tags
  calculateFilterExpression = (filterValue, selectedFilterOperation, target) => {
    if (target === "headerFilter") {
      // For header filter, filterValue is the tag ID
      return (rowData) => {
        return rowData.tags && Array.isArray(rowData.tags) && rowData.tags.includes(filterValue);
      };
    }
    // For search box filter
    if (filterValue && typeof filterValue === 'string') {
      return (rowData) => {
        if (!rowData.tagNames) return false;
        return rowData.tagNames.toLowerCase().indexOf(filterValue.toLowerCase()) > -1;
      };
    }
    return true;
  }

  searchValueChanged(e) {
    this.searchValue = e.value;
    this.searchFilter = [
      ['name', 'contains', this.searchValue],
      'or',
      ['phone', 'contains', this.searchValue],
      'or',
      ['phoneMobile', 'contains', this.searchValue],
      'or',
      ['email', 'contains', this.searchValue],
      'or',
      ['address', 'contains', this.searchValue],
    ];
    this.applyFilter();
  }

  applyFilter() {
    this.companyGrid.instance.filter([this.searchFilter]);
  }

  onCellPrepared(e) {
    if (this.searchValue) {
      let title = e.displayValue;
      if (title != null) {
        let index = title.toLowerCase().indexOf(this.searchValue.toLowerCase());
        if (index != -1) {
          let match = title.slice(index, index + this.searchValue.length);
          var searchMatchString = "<span class='search-text'>" + match + "</span>";
          title = title.split(match).join(searchMatchString);
          var result = "<div>" + title + "</div>";
          e.cellElement.innerHTML = result;
        }
      }
    }
  }

  highlightText(text: string): string {
    if (this.searchValue && typeof text === 'string') {
      let index = text.toLowerCase().indexOf(this.searchValue.toLowerCase());
      if (index != -1) {
        let match = text.slice(index, index + this.searchValue.length);
        var searchMatchString = "<span class='search-text'>" + match + "</span>";
        text = text.split(match).join(searchMatchString);
      }
    }
    return text;
  }
}